@if (facetCategoryList$ | async; as facets) {
  @for (facetCategory of facets?.facetCategories; track facetCategory.code) {
    <section class="facet-category-list" [attr.data-test]="'product-category--filters-' + facetCategory.code + '-list'">
      <dp-facet-category
        [attr.data-test]="'product-category--filters-' + facetCategory.code+ '-category'"
        [facetCategory]="facetCategory"
        role="group"
        [attr.aria-label]="facetCategory.name"
      />
      <dp-active-facets
        [attr.data-test]="'product-category--filters-' + facetCategory.code + 'active'"
        [maxHeight]="72"
        (heightChanged)="onExceeded(facetCategory.code,$event)"
        [activeFacets]="facets.activeFacets | activeFacetByCategory : facetCategory.code"
        [ngClass]="{truncated: !showAllFilters()}"
      />
    </section>
  }
}
